<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import Link from "./Link.svelte";
	import translations from "./HomepageAboutUs.translations.json";
	import aboutSm from "../assets/images/homepage/about-us-section.png?webp&w=800&imagetools";
	import aboutMd from "../assets/images/homepage/about-us-section.png?webp&w=1200&imagetools";
	import aboutLg from "../assets/images/homepage/about-us-section.png?webp&w=1600&imagetools";
	import aboutXl from "../assets/images/homepage/about-us-section.png?webp&w=1920&imagetools";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import { aboutPathMap } from "../../../core/schema/paths/aboutPathMap.js";
	import { getTenant } from "../getTenant.js";

	const translate = getTranslate(translations);
	const tenant = getTenant();
</script>

<div class="relative overflow-hidden py-8 md:py-16 lg:py-24">
	<StaticPicture
		image={aboutXl}
		alt={translate("aboutUs")}
		height={800}
		width={1920}
		loading="eager"
		class="pointer-events-none absolute inset-0 z-0"
		imgClass="absolute inset-0 size-full object-cover"
		sourcesets={{
			"<md": aboutSm,
			">md": aboutMd,
			">lg": aboutLg,
			">xl": aboutXl,
		}}
	/>
	<div class="border-ltprimary-300 relative z-10 border-y">
		<div class="mx-auto max-w-[120rem]">
			<div
				class="mx-10 flex flex-col md:mx-[5.125rem] lg:mx-[8.125rem] lg:min-h-[30rem] xl:grid xl:min-h-[38rem] xl:grid-cols-2"
			>
				<div class="border-ltprimary-300 border-x pt-5 max-md:px-2 md:pl-8 md:pt-8 xl:border-x-0 xl:border-l">
					<h2
						class="text-ltprimary mb-4 text-center font-light uppercase tracking-wider md:text-left lg:text-xl xl:mb-0 xl:text-2xl/none"
					>
						{translate("aboutUs")}
					</h2>
				</div>

				<div class="border-ltprimary-300 flex flex-col justify-between gap-6 border-x px-8 xl:pt-8">
					<p class="font-lexend text-ltprimary !text-2md mx-auto font-normal lg:mx-[initial]">
						{translate("content")}
					</p>

					<div class="mb-8 flex">
						<Link asButton variant="primary" icon={arrowRight} href="/{aboutPathMap[tenant.locale]}">
							{translate("readMore")}
						</Link>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
